import { useRyanAuth } from '../context/RyanAuthContext';

export function useRyanAccess() {
  return useRyanAuth();
}
